import { hasPermission, PERMISSIONS } from "./hasPermission";

/**
 * True when the authenticated user can access the admin reports dashboard.
 * EN-4961: switched from the Cognito-derived `portalPreferences.isAdmin` flag
 * to the new permission-based check. Kept as a named util so callsites that
 * gate the "Admin portal" UI option don't need to know the permission code.
 */
export function isAdminUser(): boolean {
  return hasPermission(PERMISSIONS.ADMIN_REPORTS_READ);
}
